import { ClientManagerInstanceToken, CustomInjector, DateUtilities, ConfigInstanceToken } from '@evorait/pace-core';
import moment from 'moment';

export default class StartWorkModel {
    public endOfWorkTime: string;
    public endOfWork: moment.Moment;
    public startOfWorkTime: string;
    public startOfWork: moment.Moment;
    public frontId: string;
    public constructor(submittedEndOfWork: moment.Moment) {
        const injector = CustomInjector.getInjector();

        const configService = injector.get(ConfigInstanceToken);
        const clientManager = injector.get(ClientManagerInstanceToken);

        this.frontId = configService.getUserFrontId();
        this.startOfWork = moment().startOf('minute');
        this.startOfWorkTime = this.startOfWork.format(clientManager.getTimeFormat());

        this.endOfWork = submittedEndOfWork;
        if (this.endOfWork.isValid()) {
            this.endOfWorkTime = this.endOfWork.format(clientManager.getTimeFormat());
        }
    }

    public get endOfWorkDate(): string {
        return this.endOfWork.isValid() ? DateUtilities.formatDate(this.endOfWork) : '';
    }

    public get startOfWorkDate(): string {
        return DateUtilities.formatDate(this.startOfWork);
    }
}
